import { useState } from 'react';
import classNames from 'classnames/bind';

import { MochiLottie } from '@autopass-web/mochi-component';

import { MochiCarousel } from '../..';
import { PARKING_TUTORIAL_VERTICAL_LIST_DATA } from '../../const';
import styles from './mochi-parking-tutorial-carousel.module.sass';

const cx = classNames.bind(styles);

interface MochiParkingTutorialCarouselProps {
  isPlay?: boolean;
  parkingServiceType: 'autopass';
}

export const MochiParkingTutorialCarousel = ({
  isPlay,
  parkingServiceType,
}: MochiParkingTutorialCarouselProps) => {
  const [index, setIndex] = useState<number>(0);
  const list = PARKING_TUTORIAL_VERTICAL_LIST_DATA[parkingServiceType];

  return (
    <MochiCarousel
      onSlideChange={(index) => setIndex(index)}
      items={list.map(({ lottie, content, id }, i) => (
        <div className={cx('item-container')} key={id}>
          <MochiLottie
            stopped={isPlay && i !== index}
            animationData={lottie}
            loop
          />
          <p className={cx('item-content')}>{content}</p>
        </div>
      ))}
    />
  );
};
